import YandexAccountAttach from "@/pages/YandexOauth/YandexAccountAttach.vue";

console.log('SCRIPT START')


import { createApp } from 'vue'
import App from './App.vue'
import {createRouter, createWebHistory} from 'vue-router'
import LoginPage from '@/pages/Login/LoginPage.vue'
import WorkspaceView from './pages/Workspace/WorkspaceView.vue'
import FlowView from './pages/Flow/FlowView.vue'
import UserProfile from '@/pages/UserProfile/IndexView.vue'
import './assets/style.css'
import { store } from './store/store.js'
import { emitter } from "@/service/modalEventBus";
import CodeAcception from '@/pages/Login/CodeAcception.vue'
import GoogleOauth from './pages/GoogleOauth/GoogleOauth.vue'
import SubscriptionsViewSecond from './pages/Subscriptions/SubscriptionsViewSecond.vue'
import SubscriptionsPricingView from './pages/Subscriptions/SubscriptionsPricingView.vue'
import RegisterPage from "@/pages/Login/RegisterPage.vue";
import {AuthApi} from "@/service/authApi";
import {Api} from "@/service/api";
import {
    ensureFreshAccessToken,
    hasAccessToken,
    startAuthSessionWatchers,
} from "@/service/authSession";
import PasswordResetRequest from "@/pages/PasswordReset/PasswordResetRequest.vue";
import PasswordReset from "@/pages/PasswordReset/PasswordReset.vue";
import ConnectionUpdate from "@/pages/CreateConnection/ConnectionUpdate.vue";
import TransactionJournal from "@/pages/TransactionJournal/TransactionJournal.vue";
import GooglePickerPage from "@/components/GooglePickerPage.vue";
import YandexOauth from "@/pages/YandexOauth/YandexOauth.vue"
import VKOauth from "@/pages/VKOauth.vue";
import VueYandexMetrika from 'vue3-yandex-metrika'
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import IntegrationsView from "@/pages/Integrations/IntegrationsView.vue";
import CreateConnectionView from "@/pages/CreateConnection/IndexView.vue";
import PaymentInfo from "@/pages/Subscriptions/PaymentInfo.vue";
import VKAdsAccounts from "@/pages/VKAdsAccounts/VKAdsAccounts.vue";
import YandexFilesTest from "@/pages/YandexOauth/YandexFilesTest.vue";
import BitrixOauth from "@/pages/BitrixOauth/BitrixOauth.vue";


const routes = [
    {
        name: "SubscriptionsView",
        path: "/subscriptions",
        component: SubscriptionsViewSecond,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "SubscriptionPricingView",
        path: "/subscriptions/pricing",
        component: SubscriptionsPricingView,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "GoogleOauth",
        path: "/google/oauth",
        component: GoogleOauth,
        meta: {
            requiresAuth: true
        }
    },
    {
      name: "IntegrationsView",
      path: "/integrations",
      component: IntegrationsView,
      meta: {
          requiresAuth: true
      }
    },
    {
        name: 'LoginPage',
        path: "/login",
        component: LoginPage,
        meta: {
            hideForAuth: true
        }
    },
    {
        name: "PasswordResetRequest",
        path: "/request-password-reset",
        component: PasswordResetRequest,
        meta: {
            hideForAuth: true
        }
    },
    {
        name: "PasswordReset",
        path: "/password-reset",
        component: PasswordReset,
        meta: {
            hideForAuth: true
        }
    },
    {
        name: 'CodeAcception',
        path: "/login/code",
        component: CodeAcception,
        meta: {
            requiresAuth: true,
            withoutCodeAccept: true
        }
    },
    {
        name: 'WorkspaceView',
        path: '/workspace',
        component: WorkspaceView,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "FlowView",
        path: '/workflows/:workflow_id/connections/',
        component: FlowView,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "ConnectionUpdate",
        path: '/workflows/:workflow_id/connections/:connection_id/edit',
        component: ConnectionUpdate,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "GooglePickerPage",
        path: '/google/picker',
        component: GooglePickerPage,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "ProfileView",
        path: '/me',
        component: UserProfile,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "CreateConnection",
        path: "/workflows/:workflow_id/connections/create",
        component: CreateConnectionView,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "RegisterPage",
        path: "/register",
        component: RegisterPage,
        meta: {
            hideForAuth: true
        }
    },
    {
        name: "TransactionJournal",
        path: "/workflows/:workflow_id/transactions",
        component: TransactionJournal,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "PaymentInfo",
        path: "/payment",
        component: PaymentInfo,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "YandexOauth",
        path: "/yandex/oauth",
        component: YandexOauth,
        meta: {
            hideForAuth: true
        }
    },
    {
        name: "YandexAccountAttach",
        path: "/yandex/account/attach",
        component: YandexAccountAttach,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "BitrixOauth",
        path: "/bitrix/oauth2",
        component: BitrixOauth,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "VKOauth",
        path: "/vk/oauth",
        component: VKOauth,
        meta: {
            hideForAuth: true
        }
    },
    {
        name: "VKOauth",
        path: "/accounts/vk/ads",
        component: VKAdsAccounts,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: "UserProfileNew",
        path: "/profile/me",
        redirect: "/me",
    },
    {
        name: "YandexFilesTest",
        path: "/yandex/test",
        component: YandexFilesTest,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: () => {
            // Логика редиректа в зависимости от авторизации
            const isAuthenticated = !!localStorage.getItem("accessToken");

            if (isAuthenticated) {
                return { name: 'WorkspaceView' };
            } else {
                return { name: 'LoginPage' };
            }
        }
    }

]

const router = createRouter({
    history: createWebHistory(),
    routes: routes  
})

function isAuthFailure(error) {
    return error?.response?.status === 401 || error?.response?.status === 403;
}

function isTransientFailure(error) {
    if (!error?.response) {
        return true;
    }

    return error.response.status >= 500;
}

// Вспомогательные функции
const helpers = {
    /**
     * @returns {Promise<'authenticated'|'unauthenticated'|'transient'>}
     */
    async getAuthState() {
        const refreshed = await ensureFreshAccessToken();
        if (refreshed.status !== 'success' && !hasAccessToken()) {
            return 'unauthenticated';
        }

        try {
            await Api.isUserConfirmed();
            return 'authenticated';
        } catch (error) {
            if (isAuthFailure(error)) {
                const forcedRefresh = await ensureFreshAccessToken(0, { force: true });
                if (forcedRefresh.status !== 'success') {
                    return 'unauthenticated';
                }

                try {
                    await Api.isUserConfirmed();
                    return 'authenticated';
                } catch (retryError) {
                    if (isAuthFailure(retryError)) {
                        return 'unauthenticated';
                    }
                    if (isTransientFailure(retryError) && hasAccessToken()) {
                        return 'transient';
                    }
                    return 'unauthenticated';
                }
            }

            if (isTransientFailure(error) && hasAccessToken()) {
                return 'transient';
            }

            return 'unauthenticated';
        }
    },

    async isAuthenticated() {
        const state = await helpers.getAuthState();
        return state === 'authenticated' || state === 'transient';
    },

    async clearAuth() {
        try {
            await AuthApi.logout();
        } catch (e) {
            console.error("Logout error:", e);
        }
        localStorage.removeItem("isUserConfirmed");
        localStorage.removeItem("expiresAt");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("tokenType");
    },

    async checkAndRefreshToken() {
        const result = await ensureFreshAccessToken();
        return result.status === 'success' || hasAccessToken();
    },

    /**
     * @returns {Promise<true|false|'unauthorized'|'transient'>}
     */
    async checkUserConfirmation() {
        const cached = localStorage.getItem("isUserConfirmed") === "true";
        if (cached) return true;

        try {
            const { is_user_confirmed } = await Api.isUserConfirmed();
            if (is_user_confirmed) {
                localStorage.setItem("isUserConfirmed", "true");
            }
            return Boolean(is_user_confirmed);
        } catch (error) {
            if (isAuthFailure(error)) {
                return 'unauthorized';
            }
            if (isTransientFailure(error)) {
                return 'transient';
            }
            throw error;
        }
    }
};

router.beforeEach(async (to, from, next) => {
    console.log("DEBUG - Navigation:", to.path);

    try {
        const requiresAuth = to.matched.some(r => r.meta.requiresAuth);
        const hideForAuth = to.matched.some(r => r.meta.hideForAuth);
        const withoutCodeAccept = to.matched.some(r => r.meta.withoutCodeAccept);

        let authState = 'unauthenticated';
        if (requiresAuth || hideForAuth) {
            authState = await helpers.getAuthState();
        }

        const authenticated = authState === 'authenticated' || authState === 'transient';

        if (requiresAuth) {
            if (authState === 'unauthenticated') {
                await helpers.clearAuth();
                return next({ name: 'LoginPage' });
            }

            if (withoutCodeAccept) {
                return next();
            }

            const confirmed = await helpers.checkUserConfirmation();

            if (confirmed === 'unauthorized') {
                await helpers.clearAuth();
                return next({ name: 'LoginPage' });
            }

            if (confirmed === 'transient') {
                return next();
            }

            if (!confirmed) {
                return next({ name: "CodeAcception" });
            }

            return next();
        }

        if (hideForAuth && authenticated) {
            const confirmed = await helpers.checkUserConfirmation().catch(() => 'transient');

            if (confirmed === true) {
                const { redirect, plan, length } = to.query;

                if (redirect === 'subscriptions') {
                    return next({
                        name: "SubscriptionPricingView",
                        query: { plan, length }
                    });
                }

                return next({ name: "WorkspaceView" });
            }

            if (confirmed === false) {
                return next({ name: "CodeAcception" });
            }

            if (confirmed === 'unauthorized') {
                await helpers.clearAuth();
            }
        }

        next();

    } catch (error) {
        console.error("Router guard error:", error);
        if (to.matched.some(r => r.meta.requiresAuth)) {
            if (hasAccessToken()) {
                return next();
            }
            await helpers.clearAuth();
            next({ name: 'LoginPage' });
        } else {
            next();
        }
    }
});

console.log(1)

const app = createApp(App)

console.log(2)

const clickOutside = {
    beforeMount: (el, binding) => {
        el.clickOutsideEvent = event => {
            if (!(el === event.target || el.contains(event.target))) {
                binding.value();
            }
        };
        document.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted: el => {
        document.removeEventListener("click", el.clickOutsideEvent);
    },
};

window.closeWindow = function(selfWindow){
    selfWindow.close();
}


app.directive( 'click-outside', clickOutside)
app.use(router)
app.use(store)
app.use(VCalendar, {})
app.use(VueYandexMetrika, {
    id: 105125614,
    env: 'production',
    options: {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        ecommerce: "dataLayer",
    },
    router:router
})
app.config.globalProperties.emitter = emitter
startAuthSessionWatchers()
app.mount('#app')

